import { render, staticRenderFns } from "./cabinet-commercial-notices-list.vue?vue&type=template&id=c2ba31c0&"
import script from "./cabinet-commercial-notices-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notices-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ba31c0')) {
      api.createRecord('c2ba31c0', component.options)
    } else {
      api.reload('c2ba31c0', component.options)
    }
    module.hot.accept("./cabinet-commercial-notices-list.vue?vue&type=template&id=c2ba31c0&", function () {
      api.rerender('c2ba31c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cabinet-commercial-notices-list.vue"
export default component.exports